import { Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import GroupsIcon from '@mui/icons-material/Groups'
import { AppBox } from 'src/component/common/analog/molecule/AppBox'
import { ColorTokens, Palette } from 'src/feature/theme/model/Palette'
import { ReactNode } from 'react'
import { useLocalizationStore } from 'src/feature/localization/store/localization.store'
import { observer } from 'mobx-react-lite'

type PerformanceOverviewCardsProps = {
  templateCount: number
  onCreateClick: () => void
}

type ActionTileProps = {
  label: string
  value?: string | number
  icon: ReactNode
  onClick?: () => void
}

export function ActionTile({ label, value, onClick, icon }: ActionTileProps) {
  return (
    <AppBox sx={styles.card} onClick={onClick}>
      <AppBox sx={{ display: 'flex', flexDirection: 'row', gap: 10, alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant='body1' sx={{ color: 'text.secondary' }}>{label}</Typography>

        <AppBox sx={styles.iconTile}>{icon}</AppBox>
      </AppBox>

      <Typography variant="h2">{value}</Typography>
    </AppBox>
  )
}

export const PerformanceOverviewCards = observer(({
  templateCount,
  onCreateClick,
}: PerformanceOverviewCardsProps) => {
  const { translation } = useLocalizationStore()

  const performanceReviewTranslation = translation.pages.myTeam.performanceReview

  return (
    <AppBox sx={styles.container}>
      <ActionTile
        label={performanceReviewTranslation.addTemplate()}
        onClick={onCreateClick}
        icon={
          <AddIcon sx={styles.icon} />
        }
      />

      <ActionTile
        label={performanceReviewTranslation.totalReviews()}
        value={templateCount}
        icon={
          <GroupsIcon sx={styles.icon} />
        }
      />
    </AppBox>
  )
})

const styles = {
  container: {
    display: 'flex',
    gap: 20,
    width: '100%',
  },
  card: {
    flexDirection: 'column',
    borderRadius: '12px',
    backgroundColor: ColorTokens.neutral100,
    padding: '10px 15px',
    minWidth: 180,
    gap: 5,
    cursor: 'pointer',
  },
  iconTile: {
    width: 38,
    minWidth: 38,
    height: 38,
    borderRadius: '12px',
    backgroundColor: ColorTokens.primary200,
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    fontSize: 30,
    color: Palette.CORAL_REEF_GREEN,
  },
} as const